import AssetBalancesChart from './assetBalancesChart';

export default AssetBalancesChart;